export function intervalStringToMilliseconds(iso8601Duration) {
    const iso8601DurationRegex = /(-)?P(?:([.,\d]+)Y)?(?:([.,\d]+)M)?(?:([.,\d]+)W)?(?:([.,\d]+)D)?T(?:([.,\d]+)H)?(?:([.,\d]+)M)?(([.,\d]+)S)?/;
    const matches = iso8601Duration.match(iso8601DurationRegex);
    const o = {
        sign: matches[1] === undefined ? '+' : '-',
        years: matches[2] === undefined ? 0 : parseInt(matches[2]),
        months: matches[3] === undefined ? 0 : parseInt(matches[3]),
        weeks: matches[4] === undefined ? 0 : parseInt(matches[4]),
        days: matches[5] === undefined ? 0 : parseInt(matches[5]),
        hours: matches[6] === undefined ? 0 : parseInt(matches[6]),
        minutes: matches[7] === undefined ? 0 : parseInt(matches[7]),
        seconds: matches[8] === undefined ? 0 : parseInt(matches[8]),
        milliseconds: 0
    };
    const secondFractions = matches[8] && matches[8].split('.')[1] ? matches[8].split('.')[1] : undefined;
    const msLength = secondFractions ? secondFractions.replace(/\D/g, '').length : 0;
    const msNumber = secondFractions ? parseInt(secondFractions) : 0; // somehow parseInt cuts off the last digit in the string
    o["milliseconds"] = msLength > 0 ? msNumber * (Math.pow(10, 3 - msLength)) : 0;
    const hToMs = 60 * 60 * 1000;
    const mToMs = 60 * 1000;
    const sToMs = 1000;
    return (o.hours * hToMs) + (o.minutes * mToMs) + (o.seconds * sToMs) + (o.milliseconds);
}